import React from 'react';

const AboutMe = () => {
    return (
        <div className="mt-6 mx-4 ">
            <h3 className="font-bold text-gray-900">ABOUT ME</h3>
            <div className="w-32 h-32 mt-4 mx-auto bg-orange-600 rounded-full"></div>
            <div className="mt-2 text-center font-light text-gray-500">
                Duis eget imperdiet dolor, sit amet aliquet lorem. Sed sed
                placerat metus. Pellentesque est nisl, molestie quis finibus
                vitae.
            </div>
        </div>
    );
};

export default AboutMe;
